<template>
  <div>
    <div v-imloading="loading" class="overflow-hidden site-wrapper"
      :class="[prefixCls, model.globalSetting.standAloneMode && StandAloneClassName]" :style="getStyle">
      <div v-show="isShowBackgroundImage(computeGlobalBackgroundStyle)" class="site-back-ground-image"
        :style="computeGlobalBackgroundStyle" />
      <div v-show="isShowColor(model.globalSetting)" class="site-background-color" />
      <div id="site-body" :key="playerId" class="h-[100vh] overflow-auto site-content relative">
        <module-navigation-widget :model="model.moduleNavigationSetting" :site="model" :device="device" />
        <template v-for="(w, index) in model.widgetList">
          <component :is="w.name.replace('Model', '')" v-if="checkWidgetVisible(w)" :id="w.id" :key="w.id + index" class="widget-item" :model="w" :site="model" :device="device" :editing="false" />
        </template>
      </div>
      <site-modals :device="device" :site="model" />
    </div>
    <CheckWeChat v-if="isShowWeChatModal" />
    <pay-modal />
    <support-setting-widget :model="supportSetting" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash-es';
import { computeBackgroundStyle, isShowColor, isShowBackgroundImage } from '~/site/model/helper'
import { useGlobSetting } from "~/hooks/useGlobSetting"
import { widgetComponents } from '~/site/model/components'
import { DeviceEnum } from '~/enums/deviceEnum'
import { StandAloneClassName } from '~/enums/DomEnum'
import { isWeChat } from '~/utils/types'
import SiteModals from '~/site/components/modals'
import { PageEnum } from '~/enums/pageEnum'
import EventTrackerMixins from '~/mixins/eventTracker'
import CheckWeChat from '~/site/components/checkWeChat'
import Bus from "~/site/model/bus"
import PayModal from "~/components/pay/modal.vue";
import { WidgetModelNames } from '~/enums/siteEnum';
import { scrollToModuleById } from '~/utils'

export default {
  name: "SiteIndex",
  components: {
    PayModal,
    SiteModals,
    CheckWeChat,
    ...widgetComponents
  },

  mixins: [EventTrackerMixins],

  props: {
    model: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },

    whiteList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    const { prefixCls } = useGlobSetting()

    return {
      StandAloneClassName,
      prefixCls: prefixCls + '-preview',
      loading: false,
      computeBackgroundStyle,
      isShowColor,
      isShowBackgroundImage,
      isShowWeChatModal: false
    }
  },
  computed: {
    getStyle() {
      let style = {}
      const { globalSetting } = this.model
      if (globalSetting) {
        style = globalSetting.__vars
      }
      this.$parent?.$parent?.$emit('change-style', style)
      return style
    },
    ...mapState({
      device: state => state.device?.device,
      playerId: state => state.user?.uuid,
      projectInfo: (state) => state.project.info,
    }),
    computeGlobalBackgroundStyle() {
      if (!this.model && this.model.globalSetting) {
        return {}
      }
      const gSetting = { ...this.model.globalSetting }
      const bgImage = gSetting.backgroundImage
      if (this.device === DeviceEnum.MOBILE) {
        Object.assign(gSetting, gSetting.mobileBackground)
        if (!gSetting.backgroundImage) {
          gSetting.backgroundImage = bgImage
        }
      }
      return computeBackgroundStyle(gSetting)
    },
    whiteListComputed() {
      return this.whiteList
    },
    supportSetting() {
      return this.model.supportSetting
    },
    menuManageModel() {
      const listSet = new Set()
      const menuManages = this.model.widgetList.filter(item => item.name === WidgetModelNames.MenuManageWidgetModel)
      const selected = this.$store.state.site.menuManageSelected
        .map(item => item.modelIds || [])
        .flat()
        .filter(Boolean)
      menuManages.forEach(item => {
        (item.navs || []).forEach(nav => {
          const ids = nav.models || []
          ids.filter(Boolean).forEach(id => listSet.add(id))
        })
      })
      console.log(selected)
      return {
        list: Array.from(listSet),
        selected
      }
    }
  },
  watch: {},
  async mounted() {
    this.isShowWeChatModal = isWeChat()
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      await this.init()
      window.BUILD_VERSION = process.env.BUILD_VERSION
    }
  },
  beforeDestroy() {
    Bus.$off('reloadActivity')
  },
  methods: {
    checkWidgetVisible(widget) {
      const inMenuManage = this.menuManageModel.list.includes(widget.id)
      const isMenuSelect = this.menuManageModel.selected.includes(widget.id)
      if (!widget.visible || (inMenuManage && !isMenuSelect)) {
        return false
      }
      return true
    },
    async init() {
      this.setDeviceWidth()
      await this.getIpInfo()
      this.$store.commit('site/SET_GLOBAL_VARS', cloneDeep(this.getStyle))
      this.registerWidgetReadyTracker()
    },
    registerWidgetReadyTracker() {
      const tracker = this.model?.__widgetReadyTracker
      if (!tracker) return
      tracker.onload(() => this.handleModuleScroll())
    },
    handleModuleScroll() {
      const moduleId = this.$route?.query?._moduleId
      if (moduleId) {
        scrollToModuleById(moduleId)
      }
    },
    getIpInfo() {
      this.whiteListHandler()
    },

    setDeviceWidth() {
      this.$nextTick(() => {
        this.$store.commit('editor/SET_DEVICE_WIDTH',
          document.querySelector('#site-body')?.clientWidth)
      })
    },

    /**
     * 当前 ip所在的 ip_country不在白名单中，则跳转到无权限页面
     * 不在 node端直接拦截，是因为项目支持通过 x-forward-for切换 ip
     *
     * @param {*} result
     */
    whiteListHandler() {
      if (this.whiteListComputed?.length) {
        const isInWhiteList = this.$store.state.user.ipInfo.ip_country ? this.whiteListComputed?.includes(this.$store.state.user.ipInfo.ip_country) : false
        if (!isInWhiteList) {
          console.log(`FORBIDDEN_PAGE isInWhiteList: ${isInWhiteList}`)
          this.$router.push(PageEnum.FORBIDDEN_PAGE)
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.site-wrapper {
  min-height: 100%;
  overflow-y: auto;
  position: relative;

  .site-back-ground-image {
    width: 100vw;
    left: 0;
    top: 0;
    bottom: 0;
    position: absolute;
  }

  .site-background-color {
    background: var(--background-color);
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100vw;
    left: 0;
  }

  .widget-item {
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .site-content {
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
